import styled, { breakpoints } from '../../../../../styles/theme';
import { StockModelCardOptionsStyled } from '../StockModelCardOptionsStyled';
import { rem } from 'polished';

export const StockModelCardOptionsStyledAP = styled(StockModelCardOptionsStyled)`
    .stockModelCard-options {
        &--tooltipItem {
            color: ${({ theme }) => theme.colors.primary};
        }

        &--heading {
            font-size: ${rem('14px')};
        }

        &--item {
            font-size: ${rem('16px')};
            margin-left: 1rem;

            &::before {
                left: -0.8rem;
            }
        }
    }
`;
